import { isSuccessStatus } from "data/helpers/responseHelper";
import PostResponse from "data/PostResponse";
import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import Alert from "features/shared/alerts/components/Alert";
import { getAlertType } from "features/shared/alerts/components/alertHelper";
import DocumentDownload from "features/shared/components/documents/DocumentDownload";
import { Exports_ExportDocumentDialog } from "features/shared/components/loaders/promiseLoadingAreas";
import PromiseLoadingSpinner from "features/shared/components/loaders/PromiseLoadingSpinner";
import ActionResultDTO from "features/shared/dtos/ActionResultDTO";
import ValidationMessage from "features/shared/dtos/ValidationMessageDTO";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  response: PostResponse<ActionResultDTO<DocumentSimplifiedDTO[]>>;
};

const ExportDocumentsSubDialog = ({ response }: Props) => {
  // translation
  const tLabels = useTranslation("exports\\exports").t;

  // state
  const [showDownloadError, setShowDownloadError] = useState(false);

  // handlers
  const errorHandler = () => {
    setShowDownloadError(true);
  };

  // sub-renders
  const renderDocuments = (documents: DocumentSimplifiedDTO[]) => {
    return documents.map((item, index) => (
      <div className="py-2 px-3 border rounded mb-2" key={index}>
        <DocumentDownload
          document={item}
          loadingAreaName={Exports_ExportDocumentDialog}
          errorHandler={{
            catchError: true,
            onError: errorHandler,
          }}
        />
      </div>
    ));
  };

  const renderDownloadError = () => {
    if (showDownloadError) {
      return (
        <Alert
          alertObj={{
            alertType: "Danger",
            message: tLabels("exportDocumentsSubDialog.downloadErrorMessage"),
          }}
          className="mb-3"
        />
      );
    }
  };

  const renderErrors = (messages: ValidationMessage[]) => { 
    return messages.map((message, index) =>
      <Alert 
        alertObj={{
          alertType: getAlertType(message.type!),
          message: tLabels(`exportDocumentsSubDialog.${message.message!}`)
        }}
        key={index}
      />
    )
  }

  // render
  if (isSuccessStatus(response) && response.data?.result) {
    return (
      <>
        <div className="p-4">
          {renderDownloadError()}
          {renderDocuments(response.data.result)}
        </div>
        <PromiseLoadingSpinner area={Exports_ExportDocumentDialog} />
      </>
    );
  } else if (response.data?.validationMessages){
    return (
      <div className="p-4">
        {renderErrors(response.data.validationMessages)}
      </div>
    );
  } else {
    return (
      <>
      <div className="p-4">
          <Alert alertObj={{ alertType: "Danger" }}>
            <p
              className="mb-0"
              dangerouslySetInnerHTML={{
                __html: tLabels("exportDocumentsSubDialog.exportErrorMessage"),
              }}
            />
          </Alert>
        </div>
      </>
    );
  }
};

export default ExportDocumentsSubDialog;
